__webpack_public_path__ = (<any>window).asset_path;
